// Types
import { RootState } from 'types/RootState.types';

// Config
import { isMyJLMember } from '@utils/myjl/isMyJLMember';

export const shouldApplyRewards = (state: RootState): boolean => {
  const {
    orderForm: { shouldApplyRewards = false } = {},
    user: { loyaltyType = '', myJohnLewisMembershipPending = false } = {},
  } = state ?? {};

  const isApplicableMember = isMyJLMember(loyaltyType) && !myJohnLewisMembershipPending;

  if (!isApplicableMember || !shouldApplyRewards) return false;

  return true;
};

export const shouldTriggerApplyRewards = (state: RootState): boolean => {
  const {
    app: { discountsInBasketUIEnabled = false } = {},
    orderForm: { customerRemovedRewards = false, promotionsAppliedOnBasket = [], rewardInvalid = false } = {},
    user: { loyaltyType = '', myJohnLewisMembershipPending = false } = {},
  } = state ?? {};

  if (discountsInBasketUIEnabled) return false;

  const noActivePromotions =
    promotionsAppliedOnBasket.length === 0 || promotionsAppliedOnBasket.every((p) => p.isRemoved === true);
  const isApplicableMember = isMyJLMember(loyaltyType) && !myJohnLewisMembershipPending;

  return !customerRemovedRewards && noActivePromotions && isApplicableMember && !rewardInvalid;
};
